globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ChartsFrenquency = (function(){

  ChartsFrenquency.selector = 'select#chart-frequency';

  ChartsFrenquency.init = function($html) {
    $html.find(ChartsFrenquency.selector).each(function() {
      new ChartsFrenquency($(this));
    })
  }

  function ChartsFrenquency($html) {
    this.$html = $html;
    this.init();
  }

  ChartsFrenquency.prototype = {
    init: function() {
      var _this = this;

      _this.$html.on("change", function() {
        var $selected = $(this).find("option:selected"),
            $target = $($selected.data("chart-container")),
            options = $selected.data("chart-options");

        if($target.length && options) {
          $target.data("chart-options", options);
          appCustomerSpace.HighChartsChart.init($('#highcharts-container'));
        }
      });
    },
  }

  return ChartsFrenquency;

})();
